import {StrictMode} from 'react'
import * as ReactDOM from 'react-dom/client'
import {FirebaseContextProvider} from '@goschool/react-firebase'
import {CssBaseline, ThemeProvider} from '@mui/material'
import '@goschool/i18n'

import {AuthenticationContextProvider, UserContextProvider} from '@goschool/auth'
import {LandingPage, NotFound} from './app'

import * as Sentry from '@sentry/react'
import {oeTheme} from './theme'
import {ConfirmationProvider, CustomGoSchoolContextProvider} from '@goschool/components'
import {GoSchoolRoutes} from '@goschool/site'
import {BrowserRouter} from 'react-router-dom'
import {customAuth, customConfig, firebaseConfig, sentryConfig} from './config'

Sentry.init(sentryConfig)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <StrictMode>
    <CustomGoSchoolContextProvider {...customConfig}>
      <ThemeProvider theme={oeTheme}>
        <CssBaseline/>
        <FirebaseContextProvider options={firebaseConfig}>
          <UserContextProvider>
            <BrowserRouter>
              <AuthenticationContextProvider
                customConfigs={customAuth}
                enabledMethods={['email-password', 'google', 'microsoft']}>
                <ConfirmationProvider>
                  <GoSchoolRoutes App={LandingPage} NotFound={NotFound}/>
                </ConfirmationProvider>
              </AuthenticationContextProvider>
            </BrowserRouter>
          </UserContextProvider>
        </FirebaseContextProvider>
      </ThemeProvider>
    </CustomGoSchoolContextProvider>
  </StrictMode>
)



